<template>
  <div class="phoneManage">
    <header-item
      :title-array="titleArray"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <!-- <common-navbar v-if="$isFlag" /> -->
    <!-- 选择换绑类型 -->
    <ul class="phone-manage">
      <li>
        <img
          src="~assets/images/accountCenter/iphone@2x.png"
          alt=""
        >
        <div class="phone-manage__div" @click="btn_click(1)">
          <p>通过原认证手机号换绑</p>
          <p>原绑定手机还在使用，登录账号之后通过接收验证码更换绑定手机</p>
        </div>
      </li>
      <li>
        <img
          src="~assets/images/accountCenter/light_icon_face@2x.png"
          alt=""
        >
        <div class="phone-manage__div" @click="btn_click(2)">
          <p>通过人脸识别换绑</p>
          <p>原手机号不在使用，登录账号之后通过身份识别快速修改绑定手机</p>
        </div>
      </li>
      <li>
        <img
          src="~assets/images/accountCenter/light_icon_phone@2x.png"
          alt=""
        >
        <div class="phone-manage__div" @click="btn_click(3)">
          <p>通过人工申诉换绑</p>
          <p>原手机不在使用，并且账号无法登录可以通过提交账号资料人工审核更换绑定手机</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'

import sendCode from '@/mixins/sendCode'
export default {
  name: 'PhoneManage',
  components: {
    headerItem
  },
  mixins: [sendCode],
  data() {
    return {
      titleArray: ['手机号管理', '首页', '账号管理中心', '手机号管理'],
      preIndex: [],
      backFlag: true,
      currentIndex: 0
    }
  },
  watch: {
  },
  created() {},
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.phoneManage').className = ['phoneManage phoneManageH5 accountCommonH5']
    } else {
      document.querySelector('.phoneManage').className = ['phoneManage phoneManageWeb accountCommonWeb']
    }
  },
  methods: {
    navBarClick() {
      this.backFlag = false
      if (this.preIndex.length != 0) {
        this.currentIndex = this.preIndex.pop()
      } else {
        this.$router.go(-1)
      }
    },
    btn_click(key) {
      // debugger
      this.backFlag = true
      this.currentIndex = key
      if (key === 1) {
        this.$router.push('/accountCenter/accountList/phoneAuth')
      } else if (key === 2) {
        this.$router.push('/accountCenter/accountList/faceRecognitionAuth')
      } else if (key === 3) {
        // 跳转至账号申诉
        this.$router.push('/accountCenter/accountSelf/accountAppeal')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>
<style lang="stylus" scoped>

// h5
  .phoneManageH5 {
    padding-bottom: 0.5rem;
    border-radius: 10px;
    font-size: 0.25rem;
    background: #f7f8fa;
    z-index 99
    position: relative

    .phone-manage {
      width: 100%
      padding: 0 0.4rem;
      cursor: pointer;
      box-sizing: border-box

      li {
        background: #fff;
        height: 1.2rem;
        padding: 0.4rem;
        margin: 0.5rem 0;
        border-radius: 9px;
        display: flex
        align-items: center
        justify-content: space-between
        img {
          display: inline-block
          width: 0.96rem
          height: 0.96rem
        }
        .phone-manage__div {
          width calc(100% - 1.28rem)
          p:nth-child(1) {
            color: #333333;
            font-size: 0.32rem;
          }
          p:nth-child(2) {
            color: #afafaf;
            margin-top: 0.18rem;
            font-size: 0.24rem;
            line-height: 0.4rem;
          }
        }
      }
    }
  }

// web
  .phoneManageWeb {
    padding-bottom: 0.5rem;
    border-radius: 10px;
    background: #fff;
    font-size: 0.25rem;

    .phone-manage {
      width: 100%
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap !important
      padding: 0 0.6rem;
      margin: 0
      box-sizing: border-box

      li {
        width: calc(50% - 0.2rem)
        background: #f8f8f8;
        padding: 0.5rem 0.5rem 0.2rem;
        margin: 0 0 0.2rem 0
        border-radius: 9px;
        box-sizing: border-box
        display: flex
        align-items: center
        justify-content: space-between
        cursor: pointer;
        img {
          display: inline-block
          width: 1.38rem
          height: 1.38rem
        }
        .phone-manage__div {
          width calc(100% - 1.7rem)
          p:nth-child(1) {
            color: #000000;
            font-size: 0.42rem;
          }
          p:nth-child(2) {
            color: #b5b5b5;
            margin-top: 0.2rem;
            font-size: 0.32rem;
            line-height: 0.4rem;
          }
        }
      }
    }
  }
</style>
